import './main.less';
import { actions, selectors } from './';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isNull from 'lodash/isNull';
import isEmpty from 'lodash/isEmpty';
import cn from 'classname';
import Clipboard from 'react-copy-to-clipboard';

import ProgressBar from '../../modules/shared/progress-bar';
import SidebarWrap from '../sidebar/main';
import LoginForm from './components/login-form';
import LoadingSpinner from './components/loading-spinner';

const Main = props => {
	switch (true) {
		case uninitialized(props): return fetchData(props);
		case hasData(props) || hasError(props): return render(props);
		case shouldLogin(props): return renderLogin(props);
		default: throw new Error('Undefined state');
	}
};

// predicates
const uninitialized = props => {
	return !hasError(props) && isNull(props.data) && !props.shouldLogin;
};
const hasData = props => !hasError(props) && !isEmpty(props.data);
const shouldLogin = props => !hasData(props) && props.shouldLogin;
const hasError = props => !!props.error;
const hasApiErrors = props => !!props.apiErrors.length;

// functions
const fetchData = props => {
	props.fetchData();
	return <ProgressBar isAppInitProgressBar={true} />;
};

const renderLogin = props => <LoginForm {...props} />;
const render = props => (
	<div className={cn(
		'admin-layout clearfix', !(props.menuConfig && props.menuConfig.isOpen) && 'is-sidebar-collapsed'
	)}>
		<div className="admin-layout__left-sidebar">
			<SidebarWrap
				intl={props.intl}
				userData={props.data}
				debt={props.debt}
				availableCurrencies={props.availableCurrencies}
				menuConfig={props.menuConfig}
				menuToggle={props.menuToggle}
				logout={props.logout}/>
		</div>
		<div className="admin-layout__content">
			{hasApiErrors(props) && <ErrorWrapper {...props}/>}
			{ props.children }
		</div>
		{ props.shouldShowLoadingSpinner && <LoadingSpinner /> }
	</div>
);

render.propTypes = {
	children: PropTypes.element,
	intl: PropTypes.func,
	logout: PropTypes.func,
	data: PropTypes.object,
	debt: PropTypes.array,
	menuConfig: PropTypes.object,
	menuToggle: PropTypes.func,
	shouldShowLoadingSpinner: PropTypes.bool
};

fetchData.propTypes = {
	fetchData: PropTypes.func
};

const ErrorWrapper = ({apiErrors, fetchData, removeApiErrors}) => {
	return (
		<div className="mixed-error-to-render">
			<div
				className="phxl pvm flex-parent jstf-cntnt-sps-btwn flex-column bg-error-2"
			>
				<div className="flex-parent errors-table-row">
					<div className="request-error-msg mhm pvs">
						Error message
					</div>
					<div className="mhm pvs">
						Error action type
					</div>
				</div>
				{
					apiErrors.slice(-4).map((error, index)=> (
						<div className="flex-parent errors-table-row bg-error-1" key={index}>
							<div className="mhm pvs request-error-msg">
								{error.message}
							</div>
							<div className="mhm pvs">
								{error.actionType}
							</div>
							<div className="mhm">
								<Clipboard text={error.error} >
									<button
										className="ui-btn ui-btn-secondary pvs height-auto flex-center-center small-font"
									>
										Click here to copy error
									</button>
								</Clipboard>
							</div>
						</div>
					))
				}
				<div className="mvm">
					<button className="ui-btn ui-btn-secondary" onClick={removeApiErrors}>Close</button>
				</div>
			</div>
		</div>
	);
};

export default connect(
	state => ({
		data: selectors.getData(state),
		debt: selectors.getDebt(state),
		availableCurrencies: selectors.getAvailableCurrencies(state),
		apiErrors: selectors.getApiErrors(state),
		shouldLogin: selectors.getShouldLogin(state),
		shouldShowLoadingSpinner: selectors.getShouldShowLoadingSpinner(state),
		intl: selectors.getIntl(state),
		menuConfig: selectors.getMenuConfig(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/root/main.js